// @owners { team: patients }
import { EmployersEndpoint } from '@alto/scriptdash/alto/patient_app/employers/v1/employers_endpoint';
import { type DataSource } from '~shared/data-sources/types';
import { apiEndpointHandler } from '~shared/helpers/api';

export const employersDataSource: DataSource<string> = (text: string) => {
  if (text.length === 0) return Promise.resolve([]);

  return new Promise((resolve) => {
    EmployersEndpoint(apiEndpointHandler)
      .search({
        query: text,
      })
      .then((response) => {
        if (response.errors?.length) {
          resolve([]);
          return;
        }

        resolve(
          // eslint-disable-next-line promise/always-return
          response.data?.map((company) => {
            return {
              title: company.name,
              label: company.name,
              key: company.name,
              value: company.name,
            };
          }) || [],
        );
      })
      .catch(() => {
        // If the search fails, then honestly it's not a big deal.
        resolve([]);
      });
  });
};
